import { render, staticRenderFns } from "./criteria-question-panel.vue?vue&type=template&id=4e9cc854&scoped=true&"
import script from "./criteria-question-panel.vue?vue&type=script&lang=ts&"
export * from "./criteria-question-panel.vue?vue&type=script&lang=ts&"
import style0 from "./criteria-question-panel.vue?vue&type=style&index=0&id=4e9cc854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9cc854",
  null
  
)

export default component.exports